export enum Discount {
  BOGO = 'bogo',
}
